import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function IntegratedAnalyticalAndProductCharacterizationServices() {
  return (
    <div className="font-sans">


      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Product Development & Analytical Solutions', 'Integrated Analytical & Product Characterization Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Product Development & Analytical Solutions
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Integrated Analytical & Product Characterization Services
          </h3>
        </div>

        <p className="text-sm text-[#05326D] mb-4 font-bold">
          Comprehensive Solutions for Method Development, Validation, Genotoxicity, Impurity Profiling & Stability Assessment
        </p>

        {/* Section: Overview */}
        <p className="mb-4 text-[#05326D]">
          At FDAC Consultancy, we recognize that analytical development is a cornerstone of pharmaceutical quality, regulatory compliance, and product success. With decades of industry experience and access to state-of-the-art CRO laboratories, we deliver comprehensive analytical solutions tailored to the needs of formulations, APIs, and excipients across global markets.
        </p>
        <p className="mb-6 text-[#05326D]">
          Our services span from method development and validation to stability studies, genotoxicity assessments, and microbiological testing, all aligned with ICH guidelines and international pharmacopoeial standards.
        </p>

        {/* Section: Regulatory Alignment */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Global Regulatory Alignment
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Support for submissions to US FDA, EMA, MHRA, Health Canada, GCC, LATAM, South Africa, India, and more</p>
        <p className="ml-2 mt-2 text-[#05326D]">Submission formats: NDA, ANDA, 505(b)(1), 505(b)(2), EU-MAA, RoW dossiers</p>


        {/* Section: Core Analytical Services */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Core Analytical Services
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Analytical Method Development & Validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Impurity Profiling & Characterization</p>
        <p className="ml-2 mt-2 text-[#05326D]">Raw Material Qualification & Structure Elucidation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Analysis as per USP, EP, BP, IP, CP, JP</p>
        <p className="ml-2 mt-2 text-[#05326D]">ICH-compliant Stability Studies (Photostability, Bulk, In-use, Forced Degradation)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Zone-specific Stability Chambers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dissolution Profiling & Solubility Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Trace Metal & Elemental Impurity Analysis</p>
        <p className="ml-2 mt-2 text-[#05326D]">API Characterization & Routine Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Nitrosamine Risk Assessment & Method Validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Method Transfer to CMO Sites</p>
        <p className="ml-2 mt-2 text-[#05326D]">Support for Paragraph I–IV Strategies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Documentation in CTD Format</p>


        {/* Section: Genotoxicity */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Genotoxicity Assessment
          </span>
        </div>
        <p className="mb-3 text-[#05326D] font-bold">We offer in silico genotoxicity evaluations using advanced platforms:</p>
        <p className="ml-2 mt-2 text-[#05326D]">Derek Nexus (Knowledge-Based)</p>
        <p className="ml-2 mt-2 text-[#05326D]">TOPKAT (Statistical-Based)</p>
        <p className="ml-2 mt-2 text-[#05326D]">MultiCase Software</p>
        <p className="ml-2 mt-2 text-[#05326D]">(Q)SAR-Based Predictions for Bacterial Mutagenicity</p>
        <p className="ml-2 mt-2 text-[#05326D]">Alert Identification & Risk Profiling</p>
        <p className="ml-2 mt-2 text-[#05326D]">Automated Reports with Expert Review & Signed Summary</p>


        {/* Section: Microbiology */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Genotoxicity Assessment
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Microbial Limit Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Antimicrobial Efficacy Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Environmental Monitoring (Settle Plates, Air Sampling, Swabs, etc.)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Water Analysis (Chemical & Microbial)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Bacterial Endotoxin Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Antibiotic & Vitamin Assays</p>
        <p className="ml-2 mt-2 text-[#05326D]">Raw Material & Excipient Testing (Pharmacopoeial Standards)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Disinfectant Effectiveness Testing</p>


        {/* Section: Infrastructure */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Infrastructure & Equipment
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">HPLC, GC, LC/MS, IR & UV Spectrophotometers</p>
        <p className="ml-2 mt-2 text-[#05326D]">AAS, DSC, Potentiometers, Karl Fischer Titrators</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dissolution Apparatus & Stability Chambers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Facilities accredited by CAP, NABL</p>
        <p className="ml-2 mt-2 text-[#05326D]">Approved by US FDA and other international regulatory bodies</p>


        {/* Why FDAC */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Global reach with local regulatory insight</p>
        <p className="ml-2 mt-2 text-[#05326D]">Strategic CRO selection based on product type and analytical complexity</p>
        <p className="ml-2 mt-2 text-[#05326D]">Full-spectrum analytical support from development to submission</p>
        <p className="ml-2 mt-2 text-[#05326D]">Proven expertise in method validation, genotoxicity, and microbiology</p>
        <p className="ml-2 mt-2 text-[#05326D]">Seamless integration with regulatory documentation and eCTD publishing</p>


        <p className="text-[#05326D] mt-4">
          Partner with FDAC to unlock comprehensive, compliant, and innovative analytical solutions tailored to your product lifecycle and global market goals.
        </p>
      </div>
    </div>
  );
}

export default IntegratedAnalyticalAndProductCharacterizationServices;
